import type { TaskConfig, TaskMode } from './schemaTypes';
import type { TaskConditionRule, TaskRuntimeContext } from './types';
import { clientLogger } from '../utils/logger';

const matchesRule = (
  rule: TaskConditionRule,
  taskRuntimeContext?: TaskRuntimeContext,
) => {
  switch (rule.field) {
    case 'gift':
      return (
        rule.operator === 'equals' && taskRuntimeContext?.gift === rule.value
      );
    default:
      clientLogger.logError(
        new Error(
          `Unsupported task condition field: ${JSON.stringify(rule.field)}`,
        ),
        'Unsupported task condition rule',
        rule,
      );
      return false;
  }
};

const matchesConditions = (
  task: TaskConfig,
  taskRuntimeContext?: TaskRuntimeContext,
) => {
  if (!task.conditions) {
    return true;
  }

  const allPasses =
    !task.conditions.all ||
    task.conditions.all.every((rule) => matchesRule(rule, taskRuntimeContext));
  const anyPasses =
    !task.conditions.any ||
    task.conditions.any.some((rule) => matchesRule(rule, taskRuntimeContext));

  return allPasses && anyPasses;
};

export const getEffectiveMode = (
  task: TaskConfig,
  taskRuntimeContext?: TaskRuntimeContext,
): TaskMode => {
  if (!matchesConditions(task, taskRuntimeContext)) {
    return 'disabled';
  }

  return task.mode;
};
